<template>
  <section class="md:mx-12 mx-5">
    <ul class="flex gap-4 border-b pb-2">
      <li
        v-for="tab in tabs"
        :key="tab.value"
        class="border px-2 py-1.5 rounded-lg font-medium text-sm cursor-pointer"
        :class="
          tab.value === activeTab
            ? 'text-primary border-primary'
            : 'text-gray-muted border-border-color'
        "
        @click="setActiveTab(tab.value)"
      >
        {{ tab.label }}
      </li>
    </ul>
    <api-keys v-if="activeTab === 'api-keys'" />
    <ip-whitelist v-else />
  </section>
</template>
<script>
export default {
  data () {
    return {
      tabs: [
        {
          label: 'API Keys',
          value: 'api-keys'
        },
        {
          label: 'IP Whitelisting',
          value: 'ip-whitelisting'
        }
      ],
      activeTab: 'api-keys'
    }
  },
  components: {
    ApiKeys: () => import('@/components/v2/settings/apiSettings/APIKeys.vue'),
    IpWhitelist: () =>
      import('@/components/v2/settings/apiSettings/ipWhitelist/index.vue')
  },
  methods: {
    setActiveTab (tab) {
      this.activeTab = tab
    }
  }
}
</script>
